"use strict";

exports.__esModule = true;
exports.default = void 0;
var _rcSlider = _interopRequireDefault(require("rc-slider"));
require("rc-slider/assets/index.css");
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createSliderWithTooltip = _rcSlider.default.createSliderWithTooltip;
const NumberRange = createSliderWithTooltip(_rcSlider.default.Range);
const Handle = _rcSlider.default.Handle;
const Range = ({
  value,
  onChange,
  min = 0,
  max = 100,
  format = value => value
}) => {
  // if (!fetched) return <span className={'component-string-placeholder' + (fetching ? ' fetching' : '')} style={{width: `${getRandomInt(4,12)}em`}}></span>

  let prevValues = [min, max];
  const handleChange = values => {
    values.map((value, index) => {
      if (value !== prevValues[index]) onChange(value, index === 0 ? '>' : '<');
    });
    prevValues = values;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(NumberRange, {
    min: min,
    max: max,
    defaultValue: prevValues,
    tipFormatter: value => format(value),
    dots: true,
    onAfterChange: handleChange
  }));
};
var _default = exports.default = Range;
module.exports = exports.default;